"use strict";

// Background hero videos: play unless the visitor prefers reduced motion,
// pause while the tab is hidden, and give a visible play/pause toggle (WCAG 2.2.2).
const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

for (const toggle of document.querySelectorAll('[data-hero-video-toggle]')) {
    const root = toggle.closest('section');
    const videos = [...root.querySelectorAll('[data-hero-video]')];
    let wantsPlayback = !reducedMotion.matches;

    const updateLabel = () => {
        const playing = videos.some((video) => !video.paused);
        toggle.hidden = videos.length === 0;
        toggle.setAttribute('aria-label', playing ? toggle.dataset.pauseLabel : toggle.dataset.playLabel);
        toggle.querySelector('[data-icon="pause"]').classList.toggle('tw-hidden', !playing);
        toggle.querySelector('[data-icon="play"]').classList.toggle('tw-hidden', playing);
        toggle.setAttribute('aria-pressed', String(playing));
    };

    const sync = () => {
        for (const video of videos) {
            if (wantsPlayback && !document.hidden) {
                video.play().catch(updateLabel);
            } else {
                video.pause();
            }
        }
        updateLabel();
    };

    toggle.addEventListener('click', () => {
        wantsPlayback = !videos.some((video) => !video.paused);
        sync();
    });
    reducedMotion.addEventListener('change', () => {
        if (reducedMotion.matches) wantsPlayback = false;
        sync();
    });
    document.addEventListener('visibilitychange', sync);
    for (const video of videos) {
        video.addEventListener('play', updateLabel);
        video.addEventListener('pause', updateLabel);
    }
    sync();
}
